(function () {
    function initFaq() {
        const items = document.querySelectorAll('.blocks__faq__item');

        items.forEach(item => {
            const trigger = item.querySelector('.blocks__faq__question__title');
            const answer  = item.querySelector('.blocks__faq__answer');

            if (!trigger || !answer) return;

            trigger.setAttribute('role', 'button');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('tabindex', '0');

            trigger.addEventListener('click', () => toggle(item, trigger));

            trigger.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggle(item, trigger);
                }
            });
        });
    }

    function toggle(item, trigger) {
        const isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(!isOpen));
    }

    document.addEventListener('DOMContentLoaded', initFaq);
})();
